import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";
import moment from "moment";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';
import { Email } from "@mui/icons-material";

const defaultToolbarStyles = {
    iconButton: {
    },
};
var iniSales;



class PurchaseEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        var data = props.Daatta.filter(function (d) {
            return d.purchaseId === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            PurchaseId: data[0].purchaseId,
            Name: data[0].name,
            Description: data[0].description,
            Sales_Id: data[0].sales_Id,
            PurchaseTime: data[0].purchaseTime,
            DeliveryTime: data[0].deliveryTime,
            Modifier: data[0].modifier,
            StartTime: data[0].startTime,
            EndTime: data[0].endTime,
            sales: (Object.keys(props.lookupLists.sales).map((d) => ({ value: d, label: props.lookupLists.sales[d] })) || []),
        };

    }

    UNSAFE_componentWillMount() {
        iniSales = this.state.sales.find(({ value }) => value === (this.state.Sales_Id || '').toString());
        
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            PurchaseId: this.state.data[0].purchaseId,
            Name: this.state.data[0].name,
            Description: this.state.data[0].description,
            Sales_Id: this.state.data[0].sales_Id,
            PurchaseTime: this.state.data[0].purchaseTime,
            DeliveryTime: this.state.data[0].deliveryTime,
            Modifier: this.state.data[0].modifier,
            StartTime: this.state.data[0].startTime,
            EndTime: this.state.data[0].endTime
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            PurchaseId: this.state.PurchaseId,
            Name: this.state.Name,
            Description: this.state.Description,
            Sales_Id: this.state.Sales_Id,
            PurchaseTime: this.state.PurchaseTime,
            DeliveryTime: this.state.DeliveryTime,
            Modifier: this.state.Modifier,
            StartTime: this.state.StartTime,
            EndTime: this.state.EndTime
        });

        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true })
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, sales } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Purchase.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Purchase.Columns[1]}
                            type="text"
                            fullWidth
                            value={this.state.Name}
                            onChange={this.handleChange('Name')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Purchase.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Description}
                            onChange={this.handleChange('Description')}
                        />
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniSales}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Sales_Id')}
                                options={sales}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Purchase.Columns[3]} />}
                            />
                        </Box>
                        
                        <TextField
                            margin="dense"
                            label={dictionary.Purchase.Columns[4]}
                            type="date"
                            fullWidth
                            value={
                                this.state.PurchaseTime
                                    ? moment(this.state.PurchaseTime).format("YYYY-MM-DD")
                                    : ""
                            }
                            onChange={this.handleChange('PurchaseTime')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Purchase.Columns[5]}
                            type="date"
                            fullWidth
                            value={
                                this.state.DeliveryTime
                                    ? moment(this.state.DeliveryTime).format("YYYY-MM-DD")
                                    : ""
                            }
                            onChange={this.handleChange('DeliveryTime')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />

            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "PurchaseEdit" })(PurchaseEdit);
